import Vue from "vue";
import VueRouter from "vue-router";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';


// main widget
import Landing from '../pages/landing/landing'
import Home from '../components/MainWidget/Home/Home'
import AboutUs from '../components/MainWidget/AboutUs/AboutUs'
import InvestorRelations from '../components/MainWidget/InvestorRelations/InvestorRelations'
import ContactUs from '../components/MainWidget/ContactUs/ContactUs'
import Branches from '../components/MainWidget/Branches/Branches'
import Form from '../components/MainWidget/Form/Form'
import MedicalJournal from '../components/MainWidget/MedicalJournal/MedicalJournal'

import Error from '../components/MainWidget/Error/Error'
import NotFound from '../components/MainWidget/NotFound/NotFound'

// admin
import Admin from '../pages/Admin/Admin'
import LogIn from '../components/Admin/LogIn/LogIn'
import adminBranches from '../components/Admin/Branches/Branches'
import AddBranch from '../components/Admin/AddBranch/AddBranch'
import ArticlesSections from '../components/Admin/ArticlesSections/ArticlesSections'
import AddArticlesSections from '../components/Admin/ArticlesSections/AddArticlesSections'
import ArticlesSubSections from '../components/Admin/ArticlesSections/ArticlesSubSections'
import AddArticlesSubSections from '../components/Admin/ArticlesSections/AddArticlesSubSections'
import Articles from '../components/Admin/Articles/Articles'
import AddArticles from '../components/Admin/Articles/AddArticles'
import KeyPerformanceIndicators from '../components/Admin/KeyPerformanceIndicators/KeyPerformanceIndicators'
import ResultsAndReports from '../components/Admin/ResultsAndReports/ResultsAndReports'
import AddResultsAndReports from '../components/Admin/ResultsAndReports/AddResultsAndReports'
import EmploymentApplications from '../components/Admin/EmploymentApplications/EmploymentApplications'
import JobDetails from '../components/Admin/EmploymentApplications/JobDetails'
import Main from '../components/Admin/Main/Main'
import IndicatorPerformance from '../components/Admin/IndicatorPerformance/IndicatorPerformance'
import EditIndicatorPerformance from '../components/Admin/IndicatorPerformance/EditIndicatorPerformance'
import keyMetrics from '../components/Admin/IndicatorPerformance/keyMetrics'
import AdminUsers from '../components/Admin/Users/AdminUsers'
import News from '../components/Admin/News/News'
import AddNews from '../components/Admin/News/AddNews'
import FinanceMarket from '../components/Admin/FinanceMarket/FinanceMarket'
import AddFinanceMarket from '../components/Admin/FinanceMarket/AddFinanceMarket'
import Investigator from '../components/Admin/Investigator/Investigator'
import AddInvestigator from '../components/Admin/Investigator/AddInvestigator'
import Questions from '../components/Admin/AboutCompany/Questions'
import AddQuestions from '../components/Admin/AboutCompany/AddQuestions'
import AddContactsData from '../components/Admin/ContactsData/AddContactsData'
import AboutUsPageData from '../components/Admin/AboutUsPageData/AboutUsPageData'
import LogActions from '../components/Admin/LogActions/LogActions'
import HomePageData from '../components/Admin/HomePageData/HomePageData'
import HomePageSlider from '../components/Admin/HomePageSlider/HomePageSlider'
import NavBarMenu from '../components/Admin/NavBarMenu/NavBarMenu'
import HomeStatistics from '../components/Admin/HomeStatistics/HomeStatistics'
import InvestorPageSlider from '../components/Admin/InvestorPageSlider/InvestorPageSlider'
import InvestorPageData from '../components/Admin/InvestorPageData/InvestorPageData'

// Store Admin
import StoreAdmin from '../pages/StoreAdmin/StoreAdmin';
import Statistics from '../components/StoreAdmin/Statistics/Statistics';
import Products from '../components/StoreAdmin/Products/Products'
import ShowProduct from '../components/StoreAdmin/Products/ShowProduct'
import ProductsCategories from '../components/StoreAdmin/ProductsCategories/ProductsCategories'
import AddCategory from '../components/StoreAdmin/ProductsCategories/AddCategory'
import SubCategory from '../components/StoreAdmin/SubCategory/SubCategory'
import AddSubCategory from '../components/StoreAdmin/SubCategory/AddSubCategory'
import AddProduct from '../components/StoreAdmin/Products/AddProduct'
import Users from '../components/StoreAdmin/Users/Users'
import AddUsers from '../components/StoreAdmin/Users/AddUsers'
import Cities from '../components/StoreAdmin/Cities/Cities'
import District from '../components/StoreAdmin/Cities/District'
import AddCity from '../components/StoreAdmin/Cities/AddCity'
import AddDistrict from '../components/StoreAdmin/Cities/AddDistrict'
import LinkingDisticts from '../components/StoreAdmin/LinkingDisticts/LinkingDisticts'
import LinkDistrict from '../components/StoreAdmin/LinkingDisticts/LinkDistrict'
import Requests from '../components/StoreAdmin/Requests/Requests'
import Prescriptions from '../components/StoreAdmin/Prescriptions/Prescriptions'
import PrescriptionsInsurance from '../components/StoreAdmin/Prescriptions/Prescriptions-insurance'
import MyPrescriptions from '../components/StoreAdmin/Prescriptions/MyPrescriptions'
import Copouns from '../components/StoreAdmin/Copouns/Copouns'
import Companies from '../components/StoreAdmin/Companies/Companies'
import FinishedProducts from '../components/StoreAdmin/FinishedProducts/FinishedProducts'
import Reports from '../components/StoreAdmin/Reports/Reports'
import Pannars from '../components/StoreAdmin/Pannars/Pannars'
import AddPannars from '../components/StoreAdmin/Pannars/AddPannars'
import Offers from '../components/StoreAdmin/Offers/Offers'
import AddOffer from '../components/StoreAdmin/Offers/AddOffer'
import Comments from '../components/StoreAdmin/Comments/Comments'
import Availability from '../components/StoreAdmin/Availability/Availability'
import Loyalty from '../components/StoreAdmin/Loyalty/Loyalty'
import AddLoyalty from '../components/StoreAdmin/Loyalty/AddLoyalty'
import MobileNotification from '../components/StoreAdmin/MobileNotification/MobileNotification'



Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueRouter);
const routes = [
  {
    path: "/Error",
    name: "Error",
    component: Error,
  },
  {
    path: "/Not-found",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/",
    name: "Landing",
    component: Landing,
    children: [
      {
        path: "/",
        name: "Home",
        component: Home,
      },
      {
        path: "/about-us",
        name: "AboutUs",
        component: AboutUs,
      },
      {
        path: "/investor-relations",
        name: "InvestorRelations",
        component: InvestorRelations,
      },
      {
        path: "/contact-us",
        name: "ContactUs",
        component: ContactUs,
      },
      {
        path: "/branches",
        name: "Branches",
        component: Branches,
      },
      {
        path: "/form",
        name: "Form",
        component: Form,
      },
      {
        path: "/medical-journal",
        name: "MedicalJournal",
        component: MedicalJournal,
      }
    ]
  },
  {
    path: "/login",
    name: "LogIn",
    component: LogIn
  },

  // admin
  {
    path: "/admin/",
    name: "Admin",
    component: Admin,
    children: [
      {
        path: "/admin/branches",
        name: "adminBranches",
        component: adminBranches
      },
      {
        path: "/admin/add-branch/:id",
        name: "AddBranch",
        component: AddBranch
      },
      {
        path: "/admin/add-branch",
        name: "AddBranch",
        component: AddBranch
      },
      {
        path: "/admin/articles-sections",
        name: "ArticlesSections",
        component: ArticlesSections
      },
      {
        path: "/admin/articles-sections/add-articles-sections/:id",
        name: "AddArticlesSections",
        component: AddArticlesSections
      },
      {
        path: "/admin/articles-sections/add-articles-sections",
        name: "AddArticlesSections",
        component: AddArticlesSections
      },
      {
        path: "/admin/articles-sub-sections/:id",
        name: "ArticlesSubSections",
        component: ArticlesSubSections
      },
      {
        path: "/admin/articles-sub-sections/:id/add-articles-sub-sections",
        name: "AddArticlesSubSections",
        component: AddArticlesSubSections
      },
      {
        path: "/admin/articles-sub-sections/:id/add-articles-sub-sections/:subID",
        name: "AddArticlesSubSections",
        component: AddArticlesSubSections
      },
      {
        path: "/admin/articles",
        name: "Articles",
        component: Articles
      },
      {
        path: "/admin/articles/add-articles",
        name: "AddArticles",
        component: AddArticles
      },
      {
        path: "/admin/articles/add-articles/:id",
        name: "AddArticles",
        component: AddArticles
      },
      {
        path: "/admin/key-performance-indicators",
        name: "KeyPerformanceIndicators",
        component: KeyPerformanceIndicators
      },
      {
        path: "/admin/results-and-reports",
        name: "ResultsAndReports",
        component: ResultsAndReports
      },
      {
        path: "/admin/results-and-reports/add-results-and-reports",
        name: "AddResultsAndReports",
        component: AddResultsAndReports
      },
      {
        path: "/admin/results-and-reports/add-results-and-reports/:id",
        name: "AddResultsAndReports",
        component: AddResultsAndReports
      },
      {
        path: "/admin/employment-applications",
        name: "EmploymentApplications",
        component: EmploymentApplications
      },
      {
        path: "/admin/employment-applications/job-details/:id",
        name: "JobDetails",
        component: JobDetails
      },
      {
        path: "/admin/main",
        name: "Main",
        component: Main
      },
      {
        path: "/admin/indicator-performance",
        name: "IndicatorPerformance",
        component: IndicatorPerformance
      },
      {
        path: "/admin/key-metrics",
        name: "keyMetrics",
        component: keyMetrics
      },
      {
        path: "/admin/indicator-performance/edit/:id",
        name: "EditIndicatorPerformance",
        component: EditIndicatorPerformance
      },
      {
        path: "/admin/admin-users",
        name: "AdminUsers",
        component: AdminUsers
      },
      {
        path: "/admin/news",
        name: "News",
        component: News
      },
      {
        path: "/admin/news/add-news",
        name: "AddNews",
        component: AddNews
      },
      {
        path: "/admin/news/add-news/:id",
        name: "AddNews",
        component: AddNews
      },
      {
        path: "/admin/contacts-data/add",
        name: "AddContactsData",
        component: AddContactsData
      },
      {
        path: "/admin/finance-market",
        name: "FinanceMarket",
        component: FinanceMarket
      },
      {
        path: "/admin/finance-market/add-finance-market",
        name: "AddFinanceMarket",
        component: AddFinanceMarket
      },
      {
        path: "/admin/finance-market/add-finance-market/:id",
        name: "AddFinanceMarket",
        component: AddFinanceMarket
      },
      {
        path: "/admin/investigator",
        name: "Investigator",
        component: Investigator
      },
      {
        path: "/admin/investigator/add-investigator",
        name: "AddInvestigator",
        component: AddInvestigator
      },
      {
        path: "/admin/investigator/add-investigator/:id",
        name: "AddInvestigator",
        component: AddInvestigator
      },
      {
        path: "/admin/questions",
        name: "Questions",
        component: Questions
      },
      {
        path: "/admin/questions/add-questions",
        name: "AddQuestions",
        component: AddQuestions
      },
      {
        path: "/admin/questions/add-questions/:id",
        name: "AddQuestions",
        component: AddQuestions
      },
      {
        path: "/admin/about-us-page-data",
        name: "AboutUsPageData",
        component: AboutUsPageData
      },
      {
        path: "/admin/log-actions",
        name: "LogActions",
        component: LogActions
      },
      {
        path: "/admin/home-page-data",
        name: "HomePageData",
        component: HomePageData
      },
      {
        path: "/admin/home-page-slider",
        name: "HomePageSlider",
        component: HomePageSlider
      },
      {
        path: "/admin/nav-bar-menu",
        name: "NavBarMenu",
        component: NavBarMenu
      },
      {
        path: "/admin/home-statistics",
        name: "HomeStatistics",
        component: HomeStatistics
      },
      {
        path: "/admin/investor-page-slider",
        name: "InvestorPageSlider",
        component: InvestorPageSlider
      },
      {
        path: "/admin/investor-page-data",
        name: "InvestorPageData",
        component: InvestorPageData
      },
    ]
  },

  {
    path: "/store-admin/",
    name: "StoreAdmin",
    component: StoreAdmin,
    children: [
      {
        path: "/store-admin/statistics",
        name: "Statistics",
        component: Statistics
      },
      {
        path: "/store-admin/categories",
        name: "ProductsCategories",
        component: ProductsCategories
      },
      {
        path: "/store-admin/categories/add-category",
        name: "AddCategory",
        component: AddCategory
      },
      {
        path: "/store-admin/categories/add-category/:id",
        name: "AddCategory",
        component: AddCategory
      },
      {
        path: "/store-admin/sub-category/:id",
        name: "SubCategory",
        component: SubCategory
      },
      {
        path: "/store-admin/sub-category/:id/add-sub-category",
        name: "AddSubCategory",
        component: AddSubCategory
      },
      {
        path: "/store-admin/sub-category/:id/add-sub-category/:subID",
        name: "AddSubCategory",
        component: AddSubCategory
      },
      {
        path: "/store-admin/products",
        name: "Products",
        component: Products
      },
      {
        path: "/store-admin/products/show-product/:id/:code",
        name: "ShowProduct",
        component: ShowProduct
      },
      {
        path: "/store-admin/products/add-product",
        name: "AddProduct",
        component: AddProduct
      },
      {
        path: "/store-admin/products/add-product/:id",
        name: "AddProduct",
        component: AddProduct
      },
      {
        path: "/store-admin/users",
        name: "Users",
        component: Users
      },
      {
        path: "/store-admin/users/add-user",
        name: "AddUsers",
        component: AddUsers
      },
      {
        path: "/store-admin/users/add-user/:id",
        name: "AddUsers",
        component: AddUsers
      },
      {
        path: "/store-admin/cities",
        name: "Cities",
        component: Cities
      },
      {
        path: "/store-admin/cities/district/:id",
        name: "District",
        component: District
      },
      {
        path: "/store-admin/cities/district/:id/add-district/:type",
        name: "AddDistrict",
        component: AddDistrict
      },
      {
        path: "/store-admin/cities/district/:id/add-district/:type/:cityId",
        name: "AddDistrict",
        component: AddDistrict
      },
      {
        path: "/store-admin/cities/add-city",
        name: "AddCity",
        component: AddCity
      },
      {
        path: "/store-admin/cities/add-city/:id",
        name: "AddCity",
        component: AddCity
      },
      {
        path: "/store-admin/linking-disticts",
        name: "LinkingDisticts",
        component: LinkingDisticts
      },
      {
        path: "/store-admin/linking-disticts/link-district",
        name: "LinkDistrict",
        component: LinkDistrict
      },
      {
        path: "/store-admin/linking-disticts/link-district/:id",
        name: "LinkDistrict",
        component: LinkDistrict
      },
      {
        path: "/store-admin/requests",
        name: "Requests",
        component: Requests
      },
      {
        path: "/store-admin/prescriptions/mine",
        name: "MyPrescriptions",
        component: MyPrescriptions
      },
      {
        path: "/store-admin/prescriptions/cash",
        name: "Prescriptions",
        component: Prescriptions
      },
      {
        path: "/store-admin/prescriptions/insurance",
        name: "Prescriptions-insurance",
        component: PrescriptionsInsurance
      },
      {
        path: "/store-admin/copouns",
        name: "Copouns",
        component: Copouns
      },
      {
        path: "/store-admin/companies",
        name: "Companies",
        component: Companies
      },
      {
        path: "/store-admin/out-of-stock",
        name: "FinishedProducts",
        component: FinishedProducts
      },
      {
        path: "/store-admin/reports",
        name: "Reports",
        component: Reports
      },
      {
        path: "/store-admin/pannars",
        name: "Pannars",
        component: Pannars
      },
      {
        path: "/store-admin/panners/add-pannars",
        name: "AddPannars",
        component: AddPannars
      },
      {
        path: "/store-admin/panners/add-pannars/:id",
        name: "AddPannars",
        component: AddPannars
      },
      {
        path: "/store-admin/offers",
        name: "Offers",
        component: Offers
      },
      {
        path: "/store-admin/offers/add-offer",
        name: "AddOffer",
        component: AddOffer
      },
      {
        path: "/store-admin/offers/add-offer/:id",
        name: "AddOffer",
        component: AddOffer
      },
      {
        path: "/store-admin/comments",
        name: "Comments",
        component: Comments
      },
      {
        path: "/store-admin/availability",
        name: "Availability",
        component: Availability
      },
      {
        path: "/store-admin/loyalty",
        name: "Loyalty",
        component: Loyalty
      },
      {
        path: "/store-admin/loyalty/add-loyalty",
        name: "AddLoyalty",
        component: AddLoyalty
      },
      {
        path: "/store-admin/mobile-notification",
        name: "MobileNotification",
        component: MobileNotification
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((_, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router;
